export const LEGACY_PRINT_OPTION_DEFAULTS = Object.freeze({
  preco: true,
  cod_barras: true,
  imprimir_logo: false,
  considerar_referencia: false,
  considerar_codigo_interno: false,
  codigo_interno_somente_numeracao: false,
  valor_por_kg: false,
});

export const createLegacyPrintOptions = (overrides = {}) => ({
  ...LEGACY_PRINT_OPTION_DEFAULTS,
  ...overrides,
});

/**
 * Repete as dependências da tela histórica "Gerar etiquetas".
 * Somente o acionamento de código interno desliga EAN e referência; os outros
 * controles continuam independentes, inclusive quando ligados depois dele.
 */
export const changeLegacyPrintOption = (options, key, enabled) => {
  const next = createLegacyPrintOptions(options);
  const checked = Boolean(enabled);

  if (key === "considerar_codigo_interno") {
    next.considerar_codigo_interno = checked;
    next.considerar_referencia = false;
    next.cod_barras = false;
    if (!checked) next.codigo_interno_somente_numeracao = false;
    return next;
  }

  if (key === "codigo_interno_somente_numeracao") {
    next.codigo_interno_somente_numeracao = Boolean(
      next.considerar_codigo_interno && checked
    );
    return next;
  }

  if (Object.prototype.hasOwnProperty.call(next, key)) {
    next[key] = checked;
  }

  return next;
};

export const optionsWithCustomText = (options, customText) => ({
  ...createLegacyPrintOptions(options),
  texto_personalizado_etiqueta: String(customText ?? "").slice(0, 150),
});
